import { getVisiblePathSegments } from './getVisiblePathSegments';
const LINE_WIDTH_PX = 386;
export const getTruncatedPath = (path) => {
    if (!path) {
        return path;
    }
    const [rootName = '', ...restSegments] = path.split('/');
    const segments = getVisiblePathSegments({
        containerWidth: LINE_WIDTH_PX,
        restSegments,
        rootName,
    });
    return [rootName, ...segments].join('/');
};
export const isPathTruncated = (path) => Boolean(path) && getTruncatedPath(path) !== path;
